import React from "react";
import {
  Modal,
  FormGroup,
  Button,
  Grid,
  Column,
  Dropdown,
  TextInput
} from "@carbon/react";

export default function AddPropertyModal({
  isAddModalOpen,
  setIsAddModalOpen,
  selectedType,
  setSelectedType,
  selectedAdType,
  setSelectedAdType,
  PROPERTY_TYPES,
  modalForm,
  dropdownOptions,
  handleModalChange,
  validateNumericInput,
  findSelectedItem,
  requiredLabel,
  handleStartPosting,
  isContactFormValid
}) {

  return (
    <Modal
      open={isAddModalOpen}
      primaryButtonText="Start Posting Property"
      secondaryButtonText="Cancel"
      onRequestClose={() => setIsAddModalOpen(false)}
      onRequestSubmit={handleStartPosting}
      primaryButtonDisabled={!selectedAdType || !isContactFormValid()}
    >

      {/* PROPERTY TYPE */}
      <FormGroup
        legendText={
          <>
            <strong>Select Property Type</strong>{" "}
            <span style={{ color: "#da1e28" }}>*</span>
          </>
        }
        style={{ marginBottom: 16 }}
      >
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          {Object.keys(PROPERTY_TYPES).map((type) => (
            <Button
              key={type}
              kind={selectedType === type ? "primary" : "tertiary"}
              size="sm"
              onClick={() => {
                setSelectedType(type);
                setSelectedAdType("");
              }}
            >
              {type}
            </Button>
          ))}
        </div>
      </FormGroup>

      {/* AD TYPE */}
      <FormGroup
        legendText={
          <>
            <strong>Select Property Type</strong>{" "}
            <span style={{ color: "#da1e28" }}>*</span>
          </>
        }
        style={{ marginBottom: 16 }}
      >
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          {!selectedType
            ? Object.values(PROPERTY_TYPES)
                .flat()
                .filter((ad, index, self) => self.indexOf(ad) === index)
                .map((ad) => (
                  <Button
                    key={ad}
                    kind={selectedAdType === ad ? "primary" : "secondary"}
                    size="sm"
                    onClick={() => setSelectedAdType(ad)}
                  >
                    {ad}
                  </Button>
                ))
            : PROPERTY_TYPES[selectedType].map((ad) => (
                <Button
                  key={ad}
                  kind={selectedAdType === ad ? "primary" : "secondary"}
                  size="sm"
                  onClick={() => setSelectedAdType(ad)}
                >
                  {ad}
                </Button>
              ))}
        </div>
      </FormGroup>

      {/* CONTACT FORM */}
      {selectedType && selectedAdType && (
        <FormGroup legendText={<strong>Contact Information</strong>}>
          <Grid narrow>

            <Column lg={6}>
              <Dropdown
                id="postingBy"
                titleText={requiredLabel("Posting By")}
                label="Select"
                items={dropdownOptions.postingBy}
                itemToString={(item) => item?.text || ""}
                onChange={({ selectedItem }) =>
                  handleModalChange("postingBy", selectedItem?.text || "")
                }
                selectedItem={findSelectedItem(
                  dropdownOptions.postingBy,
                  modalForm.postingBy
                )}
              />
            </Column>

            <Column lg={6}>
              <Dropdown
                id="contactPerson"
                titleText="Contact Person"
                label="Select"
                items={dropdownOptions.contactPerson}
                itemToString={(item) => item?.text || ""}
                onChange={({ selectedItem }) =>
                  handleModalChange("contactPerson", selectedItem?.text || "")
                }
                selectedItem={findSelectedItem(
                  dropdownOptions.contactPerson,
                  modalForm.contactPerson
                )}
              />
            </Column>

          </Grid>

          <Grid narrow style={{ marginTop: 16 }}>

            {/* OWNER CONTACT */}
            {/* <Column lg={6}>
              <Dropdown
                id="shareOwnerNumber"
                titleText="Share Owner Number?"
                label="Select"
                items={dropdownOptions.shareOwnerNumber}
                itemToString={(item) => item?.text || ""}
                onChange={({ selectedItem }) =>
                  handleModalChange("shareOwnerNumber", selectedItem?.text || "")
                }
                selectedItem={findSelectedItem(
                  dropdownOptions.shareOwnerNumber,
                  modalForm.shareOwnerNumber
                )}
              />

              {modalForm.shareOwnerNumber === "Yes" && (
                <>
                  <TextInput
                    id="shareOwnerContact"
                    labelText={requiredLabel("Owner Contact Number")}
                    value={modalForm.shareOwnerContact}
                    onChange={(e) =>
                      handleModalChange(
                        "shareOwnerContact",
                        validateNumericInput(e.target.value)
                      )
                    }
                    placeholder="+91"
                    inputMode="numeric"
                  />

                  <TextInput
                  id="shareOwnerEmail"
                  labelText="Owner Email"
                  value={modalForm.shareOwnerEmail}
                  onChange={(e) =>
                    handleModalChange("shareOwnerEmail", e.target.value)
                  }
                  placeholder="example@gmail.com"
                  type="email"
                  pattern="^[a-zA-Z0-9._%+-]+@gmail\.com$"
                  style={{ marginTop: 8 }}
                />
                </>
              )}
            </Column>

            {/* CONTACT PERSON */}
            <Column lg={6}>
              <Dropdown
                id="contactPersonNumber"
                titleText="Contact Person Number?"
                label="Select"
                items={dropdownOptions.contactPersonNumber}
                itemToString={(item) => item?.text || ""}
                onChange={({ selectedItem }) =>
                  handleModalChange(
                    "contactPersonNumber",
                    selectedItem?.text || ""
                  )
                }
                selectedItem={findSelectedItem(
                  dropdownOptions.contactPersonNumber,
                  modalForm.contactPersonNumber
                )}
              />

              {modalForm.contactPersonNumber === "Yes" && (
                <>
                  <TextInput
                    id="contactPersonContact"
                    labelText={requiredLabel("Contact Person Number")}
                    value={modalForm.contactPersonContact}
                    onChange={(e) =>
                      handleModalChange(
                        "contactPersonContact",
                        validateNumericInput(e.target.value)
                      )
                    }
                    placeholder="+91"
                    inputMode="numeric"
                  />

                  {/* <TextInput
                    id="contactPersonEmail"
                    labelText="Email"
                    value={modalForm.contactPersonEmail}
                    onChange={(e) =>
                      handleModalChange("contactPersonEmail", e.target.value)
                    }
                    placeholder="example@gmail.com"
                    type="email"
                    pattern="^[a-zA-Z0-9._%+-]+@gmail\.com$"
                    style={{ marginTop: 8 }}
                  />*/}
                </>
              )}
            </Column>

          </Grid>
        </FormGroup>
      )}

    </Modal>
  );
}